import { Form, Select } from 'antd';
import CustomInputLabel from 'components/Label/CustomInputLabel';

const CustomSelectInput = ({
	label,
	form,
	size = 'default',
	name,
	rules,
	value,
	style,
	children,
	onChange,
	shouldUpdate,
	allowClear = true,
	showSearch = true,
	filterOption = true,
	optionFilterProp = 'children',
	placeholder = 'Select from the list',

	...rest
}) => {
	return (
		<Form.Item name={name} label={label} rules={rules} shouldUpdate={shouldUpdate} style={style}>
			{/* {disabled ? (
				<CustomInputLabel label={value ? value : form?.getFieldValue(name)} sx={{ ...style }} />
			) : ( */}
			<Select
				allowClear={allowClear}
				showSearch={showSearch}
				size={size}
				placeholder={placeholder}
				filterOption={filterOption}
				optionFilterProp={optionFilterProp}
				onChange={shouldUpdate ? () => {} : onChange}
				style={{ width: '100%' }}
				{...rest}
			>
				{children}
			</Select>
			{/* )} */}
		</Form.Item>
	);
};

export default CustomSelectInput;
